import SiderFilters from './SiderFilters'

export default SiderFilters
